import PropTypes from "prop-types";

export const dbFeatureInterface = {
  id: PropTypes.number, // unique id fro every feature
  price: PropTypes.number, // retail price
  cost: PropTypes.number, // fabricator price
  shippingCost: PropTypes.number, // shippingCost
  fabricatorCost: PropTypes.number, // discount price
}

export const featureInterface = {
  metaData: PropTypes.object,
  dbFeature: PropTypes.shape(dbFeatureInterface),
};

export const featureCollectionInterface = {
  id: PropTypes.number.isRequired,
  features: PropTypes.arrayOf(PropTypes.shape(featureInterface)),
};

export const featureGroupInterface = {
  partName: PropTypes.string.isRequired,
};

export const navItemInterface = {
  part: PropTypes.shape(featureInterface).isRequired,
}
